import React from 'react';
import { Star } from 'lucide-react';
import { DayActivity } from '../../utils/activityHelpers';
interface WeeklyActivityDotsProps {
  weeklyActivity: DayActivity[];
  color?: 'emerald' | 'indigo' | 'slate';
}
export function WeeklyActivityDots({
  weeklyActivity,
  color = 'emerald'
}: WeeklyActivityDotsProps) {
  const colorClasses = {
    emerald: 'bg-emerald-500 border-emerald-600 text-white',
    indigo: 'bg-indigo-500 border-indigo-600 text-white',
    slate: 'bg-slate-700 border-slate-800 text-white'
  };
  return <div className="flex justify-between w-full" data-id="element-4984">
      {weeklyActivity.map(day => <div key={day.label} className="flex flex-col items-center gap-1.5" data-id="element-4985">
          <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${day.practiced ? colorClasses[color] : 'bg-white border-slate-200 text-slate-400'}`} data-id="element-4986">
            {day.practiced && <Star className="w-4 h-4 fill-current" data-id="element-4987" />}
          </div>
          <span className="text-[10px] font-bold text-slate-500 uppercase" data-id="element-4988">
            {day.label}
          </span>
        </div>)}
    </div>;
}